import { useTranslation } from 'react-i18next';
import { Typography, useTheme } from '../../../base';
import {
    CardWrapper,
    ChangeIndicator,
    ContentWrapper,
    IconWrapper,
} from './StatCard.styles';
import { IStatsCard } from '../../../common';

interface Props {
    stats: IStatsCard;
}
const StatCard: React.FC<Props> = ({ stats }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <CardWrapper>
            <IconWrapper>{stats.icon}</IconWrapper>
            <ContentWrapper>
                <Typography color="text.secondary" variant="body2">
                    {stats.title}
                </Typography>
                <Typography variant="h4" fontWeight="bold">
                    {stats.value}
                </Typography>
                {stats.change && (
                    <>
                        {stats.change.isZero || stats.change.value === null ? (
                            <Typography
                                color={theme.palette.grey[600]}
                                variant="caption"
                            >
                                {t('jobsPage.noChangeFromLastWeek')}
                            </Typography>
                        ) : (
                            <ChangeIndicator
                                ispositive={
                                    stats.change?.isPositive ? 'true' : 'false'
                                }
                                variant="caption"
                            >
                                {`${stats.change?.value}% ${stats.change?.isPositive ? t('jobsPage.upFromLastWeek') : t('jobsPage.downFromLastWeek')}`}
                            </ChangeIndicator>
                        )}
                    </>
                )}
                {stats.subtitle && (
                    <Typography variant="caption" color="success.main">
                        {stats.subtitle}
                    </Typography>
                )}
            </ContentWrapper>
        </CardWrapper>
    );
};

export default StatCard;
